import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ChatInterface from "./components/ChatInterface";
import ResultsDashboard from "./components/ResultsDashboard";
import AuthCallback from "./components/AuthCallback";
import MySessions from "./components/MySessions";
import AdminDashboard from "./components/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/validate" element={<ChatInterface />} />
      <Route path="/results/:sessionId" element={<ResultsDashboard />} />
      <Route path="/my-sessions" element={<MySessions />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;